export const startsWithCaseInsensitive = (filter, row) => {
  return row[filter.id].toUpperCase().startsWith(filter.value.toUpperCase());
};

export const includesCaseInsensitive = (filter, row) => {
  return row[filter.id].toUpperCase().includes(filter.value.toUpperCase());
};
